import ActFansTotalWarGroup from '@jce/ActFansTotalWarGroupServant.js';
import './wsChannel';
import data from '@/data.js';
declare global {
  interface Window {
    Taf: any
  }
}
const getURLParam = (name: any) => {
  const value = window.location.search.match(
    new RegExp('[?&]' + name + '=([^&]*)(&?)', 'i'),
  );
  return value ? decodeURIComponent(value[1]) : value;
}
const Taf = window.Taf || null;
const callWup: (moduleName: string, funcName: string, data: any, unpackFun: any) => Promise<any> = (moduleName, funcName, data, unpackFun) => {
  const TestURL = 'http://testws.va.huya.com?timestamp=';
  const ProdURL = 'https://cdnws.api.huya.com?timestamp=';
  // eslint-disable-next-line no-nested-ternary
  // const URL = getURLParam('test') !== null ? TestURL : ProdURL;
  const URL = ProdURL;
  // eslint-disable-next-line no-undef
  const wup = new Taf.Wup();
  wup.setServant(moduleName);
  wup.setFunc(funcName);
  wup.writeStruct('tReq', data);
  const buffer = wup.encode().getBuffer();
  const timestamp = new Date().getTime();
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    Taf.Util.ajax(URL + timestamp,
      buffer,
      (value: any) => {
        // eslint-disable-next-line no-undef
        const rsp = new Taf.Wup();
        rsp.decode(value);
        // eslint-disable-next-line new-cap
        const result = new unpackFun();
        rsp.readStruct('tRsp', result, unpackFun);
        console.log(funcName, data, JSON.stringify(result));
        resolve(result);
      },
      (res: any) => {
        reject(res);
      });
  })
}

const tafFetch = (moduleName: string, data: any, requ: any, resp: any) => {
  // eslint-disable-next-line new-cap
  const req = requ === null ? null : new requ();
  Object.keys(data).forEach(key => {
    req[key] = data[key];
  })
  return callWup('wupui', moduleName, req, resp);
}


/* 公共结构体 */
interface RankItem {
  lUid: number,        // 主播uid
  iRank: number,       // 排名
  lScore: number,      // 分数
  sNickName: string,   // 昵称
  sLogoUrl: string,    // 头像
  tJump: JumpChannel,       // 跳转
  iArea: number,       // 主播所属分组
}
interface JumpChannel {
  lPid: number,       // 主播Uid
	lTid: number,       // 频道Tid
	lSid: number,       // 频道Sid
	iGameId: number,    // 品类id
	lYYId: number,      // YY
	iRoomId: number,    // roomid
	bLive: boolean,      // 是否在播
}

/* 活动阶段 */
type StageInfoReq = (
    option: {
      lPid: number,
      iMatchId: number,
    }
  ) => Promise<StageInfoRsp>
interface StageInfoRsp {
  iStage: number,
  iDay: number,
  iHour: number,
  iArea: number,
  iRevive: number,
  iMatchId: number,
  iMatchEnd: number,
}
// const getStageInfo: StageInfoReq = option => tafFetch('getStageInfo', option, ActFansTotalWarGroup.StageInfoReq, ActFansTotalWarGroup.StageInfoRsp);
const getStageInfo: StageInfoReq = option => new Promise(resolve => {
  resolve(data.getStageInfo);
});

/* 所有分区 */
type AreaConfigReq = (
    option: {
      iMatchId: number,
    }
  ) => Promise<AreaConfigRsp>
interface AreaConfigRsp {
  vAreaList: {
    value: AreaInfo[],
  }
}
interface AreaInfo {
  iArea: number,
  sName: string,
}
// const getAreaConfig: AreaConfigReq = option => tafFetch('getAreaConfig', option, ActFansTotalWarGroup.AreaConfigReq, ActFansTotalWarGroup.AreaConfigRsp);
const getAreaConfig: AreaConfigReq = option => new Promise(resolve => {
  resolve(data.getAreaConfig);
});
/* 小时冠军 */
type HourChampionReq = (
    option: {
      iMatchId: number,
      iStage: number,
      iArea: number,
    }
  ) => Promise<HourChampionRsp>
interface HourChampionRsp {
  vGroupChampion: any,  // 无用字段
  vChampionList: {
    value: ChampionInfo[],
  },
}
interface ChampionInfo {
  iHour: number,
  vChampionList: {
    value: RankItem[],
  }
}
// const getHourChampion: HourChampionReq = option => tafFetch('getHourChampion', option, ActFansTotalWarGroup.HourChampionReq, ActFansTotalWarGroup.HourChampionRsp);
const getHourChampion: HourChampionReq = option => new Promise(resolve => {
  resolve(data.getHourChampion['iMatchId' + option.iMatchId]['iStage' + option.iStage])
});


/* 分区榜单 */
type StageRankReq = (
    option: {
      iMatchId: number,
      iStage: number,
      iArea: number,
      iRevive: number,
      lPid: number,
    }
  ) => Promise<StageRankRsp>
interface StageRankRsp {
  iArea: number,          // 分区id
  vRank: {
    value: RankItem[],
  },                      // 本分区榜单列表
  iPromoteNum: number,    // 晋级人数
  tPresentInfo: any,      // 无用字段
}
// const getStageRank: StageRankReq = option => tafFetch('getStageRank', option, ActFansTotalWarGroup.StageRankReq, ActFansTotalWarGroup.StageRankRsp);
const getStageRank: StageRankReq = option => new Promise(resolve => {
  if (option.iMatchId === 1) {
    resolve(data.getStageRank.iMathch1.iStage1['iArea' + option.iArea]);
  } else {
    if (option.iRevive === 0) {
      resolve(data.getStageRank.iMathch2.iRevive0['iStage' + option.iStage]['iArea' + option.iArea]);
    } else {
      resolve(data.getStageRank.iMathch2.iRevive1.iStage1['iArea' + option.iArea]);
    }
  }
});


/* 对阵榜 */
type BattleRankReq = (
    option: {
      iStage: number,
      iArea: number,
      lPid: number,
    }
  ) => Promise<BattleRankRsp>
interface BattleRankRsp {
  iArea: number,
  vBattleList: {
    value: BattleRankItem[],
  },
  tPresentInfo: any,
}
interface BattleRankItem {
  tLeft: PkUserInfo,
  tRight: PkUserInfo,
}
interface PkUserInfo {
  tJump: JumpChannel,
	sNickName: string,
	sLogoUrl: string,
	iPkBuff: number,
	lScore: number,
}
// const getBattleRank: BattleRankReq = option => tafFetch('getBattleRank', option, ActFansTotalWarGroup.BattleRankReq, ActFansTotalWarGroup.BattleRankRsp);
const getBattleRank: BattleRankReq = option => new Promise(resolve => {
  resolve(data.getBattleRank['iStage' + option.iStage]['iArea' + option.iArea]);
});

/* 神豪榜 */
type TycoonRankReq = (
    option: {
      iArea: number,
    }
  ) => Promise<TycoonRankRsp>
interface TycoonRankRsp {
  iArea: number,
  vRankList: {
    value: RankItem[],
  },
}
// const getTycoonRank: TycoonRankReq = option => tafFetch('getTycoonRank', option, ActFansTotalWarGroup.TycoonRankReq, ActFansTotalWarGroup.TycoonRankRsp);
const getTycoonRank: TycoonRankReq = option => new Promise(resolve => {
  resolve(data.getTycoonRank['iArea' + option.iArea]);
});

interface Output {
  getStageInfo: StageInfoReq,
  getAreaConfig: AreaConfigReq,
  getHourChampion: HourChampionReq,
  getStageRank: StageRankReq,
  getBattleRank: BattleRankReq,
  getTycoonRank: TycoonRankReq,
}

const fetch: Output = {
  getStageInfo,
  getAreaConfig,
  getHourChampion,
  getStageRank,
  getBattleRank,
  getTycoonRank,
}
export {
  fetch,
  RankItem,
  StageInfoReq,
  StageInfoRsp,
  AreaConfigRsp,
  AreaInfo,
  BattleRankItem,
  PkUserInfo,
  HourChampionRsp,
  ChampionInfo,
  StageRankRsp,
  BattleRankRsp,
  TycoonRankRsp,
}